import { render, staticRenderFns } from "./widget-info-report.vue?vue&type=template&id=cd8b4d60&"
import script from "./widget-info-report.vue?vue&type=script&lang=js&"
export * from "./widget-info-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports